import {
  BeefIcon,
  BrainIcon,
  CandyOffIcon,
  DropletsIcon,
  FactoryIcon,
  SaladIcon,
  SandwichIcon,
  ShirtIcon,
  SparklesIcon,
  ZapIcon,
} from 'lucide-react'

export const painCards = [
  {
    icon: SandwichIcon,
    statement: 'Los ultraprocesados alimentan a los parásitos que viven en ti.',
    detail: 'Azúcar, harinas y aditivos son su combustible favorito.',
  },
  {
    icon: BeefIcon,
    statement: 'La carne mal cocida introduce larvas directamente a tu intestino.',
    detail: 'Tu primera línea de defensa se debilitó después de los 40.',
  },
  {
    icon: SaladIcon,
    statement: 'Los vegetales mal lavados traen quistes que sobreviven la digestión.',
    detail: 'Incluso la "comida sana" puede ser el vector de entrada.',
  },
  {
    icon: DropletsIcon,
    statement: 'El agua del grifo contiene huevos que la cloración no elimina.',
    detail: 'Se activan al llegar a la temperatura de tu cuerpo.',
  },
  {
    icon: FactoryIcon,
    statement: 'Tu cuerpo no fue diseñado para procesar 200 aditivos químicos.',
    detail: 'Cada uno debilita el ácido estomacal que los destruiría.',
  },
]

export const phases = [
  {
    number: 1,
    days: 'Días 1-7',
    name: 'Debilitamiento',
    detail: 'Abre las vías de eliminación. Elimina el combustible del invasor.',
  },
  {
    number: 2,
    days: 'Días 8-15',
    name: 'Ataque Directo',
    detail: 'Carvacrol al 85% + Semilla Negra. Pico sincronizado con luna llena.',
  },
  {
    number: 3,
    days: 'Días 16-21',
    name: 'Barrido y Sellado',
    detail: 'Limpia los restos. Repuebla. Cierra las puertas para siempre.',
  },
]

export const benefits = [
  {
    icon: ZapIcon,
    title: 'Energía antes de que suene la alarma',
    detail: 'Sin pesadez, sin luchar contra la gravedad para levantarte.',
  },
  {
    icon: BrainIcon,
    title: 'Claridad mental que no tenías hace años',
    detail: 'La niebla desaparece. Tu enfoque y memoria vuelven.',
  },
  {
    icon: ShirtIcon,
    title: 'Abdomen sin presión al final del día',
    detail: 'Esa inflamación que creías normal deja de existir.',
  },
  {
    icon: CandyOffIcon,
    title: 'Antojos de azúcar: eliminados en semana 2',
    detail: 'Recuperas la autoridad sobre lo que decides comer.',
  },
  {
    icon: SparklesIcon,
    title: 'Piel y ojos con un brillo diferente',
    detail: 'Las toxinas acumuladas salen. Tu aspecto lo refleja.',
  },
]

export const offerCards = [
  {
    badge: 'PRODUCTO PRINCIPAL',
    badgeClass: 'bg-forest text-cream',
    borderColor: '#1A3C2E',
    borderWidth: '5px',
    image: 'https://cdn.magicpatterns.com/uploads/dwHiNuXJWDwikd3xpJj5tQ/Portada_Principal.jpg',
    imageAlt: 'Portada del ebook El Método de Vaciado Biológico en una tablet',
    title: 'El Método de Vaciado Biológico',
    titleClass: 'text-forest text-xl',
    subtitle: '',
    description:
      'El protocolo exacto de 21 días con Aceite de Orégano y Semilla Negra. Actividades interactivas, rastreadores de síntomas y plan de acción día a día.',
    value: '$97 USD',
    featured: true,
  },
  {
    badge: 'BONO #1 — GRATIS',
    badgeClass: 'bg-teal/15 text-[#0A7C97]',
    borderColor: '#00B4D8',
    borderWidth: '5px',
    image: 'https://cdn.magicpatterns.com/uploads/4wjLCLWHSKcDpYfTCEsiuA/Bono_1_-_Portada.jpg',
    imageAlt: 'Portada del bono El Protocolo Antídoto',
    title: 'El Protocolo Antídoto',
    titleClass: 'text-charcoal text-lg',
    subtitle: 'Vence el Die-Off sin abandonar a mitad del camino',
    description: 'Gestiona la crisis curativa y mantén tu energía.',
    value: '$67 USD',
    featured: false,
  },
  {
    badge: 'BONO #2 — GRATIS',
    badgeClass: 'bg-terracotta/15 text-terracotta',
    borderColor: '#C4622D',
    borderWidth: '5px',
    image: 'https://cdn.magicpatterns.com/uploads/3wpFodKVxM9xtXLJuAXUtG/Bono_2_Portada.jpg',
    imageAlt: 'Portada del bono El Mapa de Hierbas Silváticas',
    title: 'El Mapa de Hierbas Silváticas',
    titleClass: 'text-charcoal text-lg',
    subtitle: 'La farmacia natural en tu cocina y jardín',
    description: '6 plantas potentes al alcance de tu mano.',
    value: '$47 USD',
    featured: false,
  },
  {
    badge: 'BONO #3 — GRATIS',
    badgeClass: 'bg-coral/15 text-coral',
    borderColor: '#E05C3A',
    borderWidth: '5px',
    image: 'https://cdn.magicpatterns.com/uploads/rFZn7Fr9Tyo1TXB9aE47yC/Bono_3_Portada.jpg',
    imageAlt: 'Portada del bono Guía del Viajero Seguro',
    title: 'Guía del Viajero Seguro',
    titleClass: 'text-charcoal text-lg',
    subtitle: 'Come en restaurantes sin miedo a reinfección',
    description: 'Tu escudo en el mundo exterior.',
    value: '$27 USD',
    featured: false,
  },
]

export const testimonialScreenshots = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/gPZfSD3yBmfUt6MMUAzCTm/testimonio_1.png',
    alt: 'Captura de WhatsApp: clienta cuenta que en su segunda semana su estómago se desinfló y se siente más ligera.',
    result: '“Mi estómago se desinfló”',
    meta: 'Semana 2 del protocolo · hinchazón',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/7UiW4noz1SrRc5EjmN9wiF/testimonio_2.png',
    alt: 'Captura de WhatsApp: cliente cuenta que a los 8 días ya no necesita 4 cafés para aguantar el día.',
    result: '“Ya no necesito 4 cafés”',
    meta: 'Día 8 del protocolo · energía y claridad',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/6jdbYAA5nUezb4Wuigu663/testimonio_3.png',
    alt: 'Captura de WhatsApp: clienta cuenta que compró el método para su esposo, notó buenos cambios en él y ahora lo aplicará ella también.',
    result: '“He notado buenos cambios en él”',
    meta: 'Semana 2 · protocolo en pareja',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/bgeejAzCEBLuWCmoVPNDwz/testimonio_4.png',
    alt: 'Captura de WhatsApp: clienta cuenta que su digestión mejoró y su piel se siente más suave.',
    result: '“Mi digestión y mi piel mejoraron”',
    meta: 'Semana 2 · digestión y piel',
  },
]

export const faqs = [
  {
    question: '¿Es seguro si tengo estómago sensible?',
    answer:
      'Sí. La Fase 1 de 7 días existe precisamente para preparar tu sistema digestivo con protectores naturales como el aceite de semilla negra — antes de cualquier intervención más intensa.',
  },
  {
    question: '¿Necesito comprar suplementos caros?',
    answer:
      'No es obligatorio. El Bono #2 (Mapa de Hierbas) te da alternativas que encuentras en cualquier mercado local o supermercado por muy poco dinero. El protocolo puede adaptarse a cualquier presupuesto.',
  },
  {
    question: '¿Voy a pasar todo el día en el baño?',
    answer:
      'No. Esto no es un laxante agresivo. Es una limpieza biológica gradual. Notarás cambios en tus evacuaciones, pero no interfiere con tu jornada laboral ni tus actividades diarias.',
  },
  {
    question: '¿Funciona para hombres también?',
    answer:
      'Sí. El protocolo está diseñado para adultos de 40+ sin distinción de género. Varios testimonios en esta página son de hombres. Los parásitos no discriminan.',
  },
  {
    question: '¿Qué pasa si no veo resultados?',
    answer:
      'Tienes 07 días completos para probarlo. Si al final de ese tiempo no sientes diferencia en tu energía, hinchazón o antojos, te devolvemos el 100% de tu dinero con un solo email. Sin preguntas, sin formularios.',
  },
  {
    question: '¿Puedo hacerlo si tomo medicamentos?',
    answer:
      'En la mayoría de los casos sí, con un simple espaciado de 2 horas entre el protocolo y tus medicamentos. Sin embargo, si tomas anticoagulantes o inmunosupresores, consulta a tu médico primero.',
  },
]
